import { RefreshCw } from "lucide-react";
import { useAuth } from "./AuthContext";
import { useExchangeState } from "./useExchangeState";

export default function ExchangeBadge() {
  const { user } = useAuth();
  const exchange = useExchangeState();

  return (
    <span className="hidden items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-[10px] font-black text-slate-300 md:flex">
      <RefreshCw aria-hidden="true" className="h-3.5 w-3.5 text-emerald-300" />
      {user?.role === "admin" && exchange?.parallelRate && exchange.officialRate && exchange.differential
        ? `${exchange.mode === "manual" ? "Manual" : "API"} · Paralelo ${exchange.parallelRate.toLocaleString("es-VE", { maximumFractionDigits: 2 })} · BCV ${exchange.officialRate.toLocaleString("es-VE", { maximumFractionDigits: 2 })} · Dif. ×${exchange.differential.toFixed(4)}`
        : exchange?.parallelRate
          ? `Paralelo ${exchange.parallelRate.toLocaleString("es-VE", { maximumFractionDigits: 2 })} Bs/USD`
          : "Tasa pendiente"}
    </span>
  );
}
